export function pickLang(obj, field, lang) {
  if (!obj) return "";
  return obj[`${field}_${lang}`] || obj[`${field}_es`] || obj[`${field}_en`] || "";
}

export function fmtDate(iso, lang = "es") {
  if (!iso) return "";
  try {
    const d = typeof iso === "string" ? new Date(iso.length === 10 ? `${iso}T00:00:00` : iso) : iso;
    if (isNaN(d.getTime())) return iso;
    const out = new Intl.DateTimeFormat(lang === "en" ? "en-US" : "es-ES", {
      weekday: "long",
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(d);
    // Capitalize the first letter so weekday reads "Domingo" / "Sunday" rather
    // than the locale default lowercase (Spanish defaults to lowercase weekdays).
    return out.charAt(0).toUpperCase() + out.slice(1);
  } catch (_) {
    return iso;
  }
}

export function fmtDateTime(iso, lang = "es") {
  if (!iso) return "";
  try {
    const d = typeof iso === "string" ? new Date(iso) : iso;
    if (isNaN(d.getTime())) return iso;
    const out = new Intl.DateTimeFormat(lang === "en" ? "en-US" : "es-ES", {
      weekday: "long",
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    }).format(d);
    return out.charAt(0).toUpperCase() + out.slice(1);
  } catch (_) {
    return iso;
  }
}

export function fmtTime12(t) {
  if (!t) return "";
  // Accept "HH:MM" or "HH:MM:SS"
  const m = String(t).match(/^(\d{1,2}):(\d{2})/);
  if (!m) return t;
  let h = parseInt(m[1], 10);
  const mm = m[2];
  if (Number.isNaN(h)) return t;
  const suffix = h < 12 ? "AM" : "PM";
  h = h % 12;
  if (h === 0) h = 12;
  return `${h}:${mm} ${suffix}`;
}

export function fmtMoney(amount, currency = "usd") {
  if (amount === null || amount === undefined) return "";
  try {
    return new Intl.NumberFormat("en-US", { style: "currency", currency: currency.toUpperCase() }).format(amount);
  } catch (_) {
    return `$${Number(amount).toFixed(2)}`;
  }
}
